// frontend-crm/src/pages/SuperAdmin/SuperAdminBots.js
import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Chip, Button } from '@mui/material';
import { useQuery } from 'react-query';
import { WhatsApp as WhatsAppIcon, Refresh as RefreshIcon } from '@mui/icons-material';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function SuperAdminBots() {
  const { data: res, isLoading } = useQuery('superadmin-tenants-bots', () =>
    fetch(`${API_URL}/api/superadmin/tenants`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(r => r.json())
  );

  const tenants = res?.data || [];

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ color: '#fff', mb: 4, fontWeight: 700 }}>Monitor de Bots WhatsApp</Typography>
      <Grid container spacing={3}>
        {tenants.map(t => (
          <Grid item xs={12} sm={6} md={4} key={t.id}>
            <Card sx={{ bgcolor: '#0D1117', border: '1px solid rgba(255,255,255,0.06)' }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <WhatsAppIcon sx={{ color: t.bot_status === 'connected' ? '#00D9A5' : '#FF6B6B' }} />
                  <Typography variant="h6" sx={{ color: '#fff' }}>{t.nombre}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Chip 
                    label={t.bot_status === 'connected' ? 'CONECTADO' : t.bot_status === 'qr-ready' ? 'ESPERANDO QR' : 'DESCONECTADO'} 
                    color={t.bot_status === 'connected' ? 'success' : 'warning'}
                    size="small"
                  />
                  <Button size="small" startIcon={<RefreshIcon />}>Reiniciar</Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
